import React from 'react';
import { Element } from 'react-scroll';
import {IconButton} from '@mui/material';
import {LinkedIn,Facebook,Instagram} from '@mui/icons-material';
import './contact.css';

export const ContactDetails = () => {
  return (
<Element className='contact' id='contact'> 
<h1>Conta<span className='spantag'>ct</span></h1>
<div className='contact-container'>
    <p>
        Email : <span>rajmohan51502@gmail.com</span>
    </p>
    <p>
        Githup Username : <span>Mohan51502</span>
    </p>
    <div className='contact-icons'>
        <a href='https://www.facebook.com/profile.php?id=100025113729760'> 
        <IconButton>
            <Facebook/>
        </IconButton>
        </a>
        <a href='https://www.instagram.com/t_w_i_n_s_o_u_l/'> 
        <IconButton>
            <Instagram/>
        </IconButton>
        </a>
        <a href='https://www.linkedin.com/in/mohanraj5/'> 
        <IconButton>
            <LinkedIn/>
        </IconButton>
        </a>

    </div>
</div>

</Element>  )
}
